import { CodedError } from '../CodedError';
import { errorCodeTypes } from './errorCodeTypes';

export class UnitNameAlreadyExistsError extends CodedError {
  static get errorName() {
    return errorCodeTypes.unitNameAlreadyExistsError.code;
  }

  constructor(message = errorCodeTypes.unitNameAlreadyExistsError.message) {
    super(message);
    this.code = errorCodeTypes.unitNameAlreadyExistsError.code;
    this.message = `${message} ${errorCodeTypes.unitNameAlreadyExistsError.code}`;
    this.name = errorCodeTypes.unitNameAlreadyExistsError.name;
  }
}
